import { DROPDOWN_PROPERTY_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DROPDOWN_PROPERTY_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DROPDOWN_PROPERTY_LIST.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case DROPDOWN_PROPERTY_LIST.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
